import type {
    IEmploymentTaxesDetailsExportGetAllResponseBody,
    IEmploymentTaxesDetailsExportRescheduleRequestBody,
    IEmploymentTaxesDetailsExportRescheduleResponseBody,
} from '@common/interfaces/api/employmentTaxesDetailsExportApi';
import { fetchJson } from '@frontend/store/fetch';
import { getUrlQueryParameters } from './queryParameterUtils';

const baseUrl = '/api/export/ubd';

export async function getAllEmploymentTaxesDetailsExports(
    signal: AbortSignal
): Promise<IEmploymentTaxesDetailsExportGetAllResponseBody> {
    const url = getUrlQueryParameters(baseUrl);
    const result = await fetchJson<IEmploymentTaxesDetailsExportGetAllResponseBody>({ method: 'GET', signal, url });

    return result.json ?? { items: [], total: 0 };
}

export async function rescheduleEmploymentTaxesDetailsExport(
    body: IEmploymentTaxesDetailsExportRescheduleRequestBody,
    signal: AbortSignal
): Promise<IEmploymentTaxesDetailsExportRescheduleResponseBody> {
    const url = getUrlQueryParameters(`${baseUrl}/reschedule`);

    const result = await fetchJson<IEmploymentTaxesDetailsExportRescheduleResponseBody>({
        body,
        method: 'POST',
        signal,
        url,
    });

    return result.json ?? { id: null };
}
